import { proxy } from 'valtio';
import {
  YodaCreateFormOptions,
  YodaFieldsState,
  YodaFormState,
  YodaGroupsState,
  YodaStepsState,
} from '../yodaForm.types';
import { useYodaForm } from './useYodaForm';
import useConst from 'hooks/useConst';

export const useYodaCreateForm = (options?: YodaCreateFormOptions) => {
  const formState = useConst<YodaFormState>(proxy({
    isValid: false,
    isDirty: false,
    isValidOptional: options?.setIsValidOptional || false,
    showError: false,
  }));
  const fieldsState = useConst<YodaFieldsState>(proxy({}));
  const groupsState = useConst<YodaGroupsState>(proxy({}));
  const stepsState = useConst<YodaStepsState>(proxy({}));

  const yodaMethods = useYodaForm({
    createdFormState: formState,
    createdFieldsState: fieldsState,
    createdGroupsState: groupsState,
    createdStepsState: stepsState,
    debounceTime: options?.debounceTime,
  });

  const providerFields = {
    formState,
    fieldsState,
    groupsState,
    stepsState,
  };

  return {
    ...yodaMethods,
    formState,
    fieldsState,
    stepsState,
    groupsState,
    providerFields,
  };
};
